import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PlaylistItemData } from "../data/PlaylistItemData";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { CyPlaylistItem } from "./CyPlaylistItem";
import { useTranslation } from "react-i18next";

interface Props {
  playlistEntry: PlaylistItemData;
  detailed?: boolean;
}

export default function PlaylistItemInvalid({
  playlistEntry,
  detailed,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <p>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className={"text-warning pe-1"}
        />
        <span data-cy={CyPlaylistItem.EntryTitle}>
          {t("playlist.item.invalidTitle")}
        </span>
      </p>
      {detailed && (
        <p>
          {t("playlist.item.invalidMessage")}
          <br />
          <small>ID: {playlistEntry.songEntryId}</small>
        </p>
      )}
    </>
  );
}
